export default __webpack_public_path__ + "static/media/1.cf1d1ead.png";